export default function gtmTag(name){
  if (typeof dataLayer !== "undefined"){
    dataLayer.push({event: name});
  }
}
